import { BoardMembersDataActionTypes } from "models/actionTypes/boardMembersDataActionTypes";
import { ReduxConstants } from "utils/constants";

export const boardMembersDataUpdated = (id: number): BoardMembersDataActionTypes => {
  return {
    type: ReduxConstants.BoardMembersDataActions.BOARD_MEMBERS_DATA_UPDATED,
    payload: id,
  };
};

export const boardMembersDataSnoozed = (id: number): BoardMembersDataActionTypes => {
  return {
    type: ReduxConstants.BoardMembersDataActions.BOARD_MEMBERS_DATA_SNOOZED,
    payload: id,
  };
};
